import React from "react";
import styled from "styled-components";
import {subHeaderBackgroundColour, tableBorderColour, triggerColour} from "../../../../style/styleConsts";

const TableRow = styled.div`
    display: flex;
    border-bottom: 1px solid ${tableBorderColour};
`;

export default TableRow;

export const PrimaryRow = styled(TableRow)`
    background: ${props => props.hasSubgroups ? subHeaderBackgroundColour : "inherit"};
`;

export const ClickablePrimaryRow = styled(PrimaryRow)`
    cursor: pointer;
    :hover {
        background-color: ${triggerColour};
        color: white;
    }
`;
